module.exports = __webpack_public_path__ + "wh-card-icon.png?f068f664e9edd108cf5ce942eb8e070d";